<template>
  <el-dialog :title="receiveData.title" :visible.sync="centerDialogVisible" @close="closeDialog" width="32%" center class="add-media">
    <el-form label-position="right" label-width="90px" :model="receiveData" v-if="receiveData.title !== '提示'">
      <el-form-item label="媒体商ID：">
        <el-autocomplete v-model="mediaInfo.UserId" :fetch-suggestions="getMediaUserList" placeholder="请输入内容" @select="handleSelect">
          <i class="el-icon-edit el-input__icon" slot="suffix">
          </i>
          <template slot-scope="{ item }">
            <el-row :gutter="20">
              <el-col :span="6"><span>{{ item.UserId }}</span></el-col>
              <el-col :span="6"> <span>{{ item.CompanyName }}</span></el-col>
            </el-row>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="公司名称：">
        <el-input v-model="mediaInfo.CompanyName" disabled></el-input>
      </el-form-item>
      <el-form-item label="媒体运营：">
        <el-input v-model="mediaInfo.SourceOperatorName" disabled></el-input>
      </el-form-item>
      <el-form-item label="媒介：">
        <el-input v-model="mediaInfo.SourcemanName" disabled></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialog">确定</el-button>
    </span>
  </el-dialog>

</template>
<script>
import { GetMediaUserList } from "api/mediaWithdraw";
export default {
  data() {
    return {
      mediaInfo: {}
    };
  },
  props: {
    dialogPragram: Object,
    isShowdialog: Boolean
  },
  computed: {
    receiveData() {
      return this.dialogPragram;
    },
    centerDialogVisible() {
      this.mediaInfo = {};
      return this.isShowdialog;
    }
  },
  methods: {
    getMediaUserList(queryString, cb) {
      GetMediaUserList({ UserId: queryString }).then(res => {
        var data = res.list ? res.list : [];
        cb(data);
      });
    },
    handleSelect(item) {
      this.mediaInfo = Object.assign({}, this.mediaInfo, item);
    },
    closeDialog() {
      this.$emit("close", 0);
    },
    confirmDialog() {
      this.dialogPragram
        .callback({ UserId: this.mediaInfo.UserId })
        .then(res => {
          this.$emit("close", 1);
        });
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";

.add-media {
   .el-dialog__header {
    background-color: #409eff;
    padding: 10px 20px 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    transform: translateY(-50%);
    .el-dialog__close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 20px 25px 0px;
    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }
  .el-select {
    width: 100%;
  }
  .el-autocomplete {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/import-preview/add-media-dialog.vue